export default {
  club_name: 'Halmstad BK',
  club_name_short: 'hbk',
  stadium_name: '',
  staging_url: 'https://hbk.api.fangroup.io',
  prod_url: 'https://hbk.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/hbk',
  club_logo: '/assets/teams/hbk.png',
  app_name: 'hbk',
  websale_name: 'hbk',
  ntb_team_id: 10037,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'hbk',
  monolithEnabled: false,
};
